// Grid card quick add: the colour circles and size buttons on the card pick the variant,
// and the card's bag button on the photo adds it through the theme's product-form (side cart).
const BOX = '[data-vc-qa]';

function variants(box) {
  if (!box._vcQa) {
    try {
      box._vcQa = JSON.parse(box.querySelector('[data-vc-qa-variants]').textContent);
    } catch (e) {
      box._vcQa = [];
    }
  }
  return box._vcQa;
}

function cardOf(box) {
  return box.closest('color-swatch') || box.closest('.card-wrapper') || box.parentElement;
}

function linkVariant(card, list) {
  const a = card.querySelector('a.card[href], .card__title a[href]');
  if (!a) return null;
  let id = null;
  try {
    id = new URL(a.getAttribute('href'), location.origin).searchParams.get('variant');
  } catch (e) {}
  return id ? list.find((v) => String(v.id) === id) || null : null;
}

function pickerHidden(card) {
  const c = card.querySelector('.card__color-swatcher--container');
  return !c || !c.querySelector('.color-swatcher--wrapper') || getComputedStyle(c).display === 'none';
}

function resolve(box) {
  const list = variants(box);
  const card = cardOf(box);
  const fromLink = linkVariant(card, list);
  const base = fromLink || list.find((v) => String(v.id) === box.dataset.vcQaDefault) || list[0];
  if (!base) return { variant: null, fallback: true };
  const wanted = base.o.slice();
  box.querySelectorAll('.vc-qa__opt').forEach((group) => {
    const on = group.querySelector('.vc-qa__btn[aria-pressed="true"]');
    if (on) wanted[Number(group.dataset.vcQaIndex)] = on.dataset.vcQaValue;
  });
  const variant = list.find((v) => v.o.every((val, i) => val === wanted[i])) || null;
  const pillIndexes = new Set([...box.querySelectorAll('.vc-qa__opt')].map((g) => Number(g.dataset.vcQaIndex)));
  const unpicked = base.o.some((_, i) => !pillIndexes.has(i) && new Set(list.map((v) => v.o[i])).size > 1);
  const fallback = !fromLink && unpicked && pickerHidden(card);
  return { variant, wanted, fallback, list };
}

function markActiveCircle(box, variant) {
  const card = cardOf(box);
  const container = card.querySelector('.card__color-swatcher--container');
  if (!container || container.querySelector('.color-swatcher--wrapper.active')) return;
  const values = new Set(variant.o);
  const wrapper = [...container.querySelectorAll('.color-swatcher--wrapper')].find((w) =>
    values.has(w.querySelector('.color-swatcher')?.dataset.color),
  );
  if (!wrapper) return;
  if (box.hasAttribute('data-vc-qa-photo-sold') && typeof card.handleClickEvent === 'function' && !box._vcQaSwapped) {
    // The photo shows a sold-out colour: show the colour the button adds instead.
    box._vcQaSwapped = true;
    const showLoader = card.showLoader;
    card.showLoader = () => {};
    card.handleClickEvent(wrapper, card.getButtonAttributes(wrapper.querySelector('.color-swatcher')), true);
    card.showLoader = showLoader;
    return;
  }
  if (!wrapper.classList.contains('hidden')) wrapper.classList.add('active');
}

function showVariantPhoto(card, variant) {
  // Cards without colour circles (e.g. Natasha pack sizes): show the chosen option's own photo.
  if (!variant.i || !pickerHidden(card)) return;
  const img = card.querySelector('.card__picture-container img, .card__media img, img');
  if (!img || img.dataset.vcQaSrc === variant.i) return;
  img.dataset.vcQaSrc = variant.i;
  img.removeAttribute('srcset');
  img.src = variant.i;
}

// A sold-out pick gets Notify me (vc-notify.js opens the restock form for this variant) in place of Add to cart.
function notifyLink(box) {
  let a = box.querySelector(':scope > [data-vc-qa-notify]');
  if (a) return a;
  const link = cardOf(box).querySelector('a.card[href*="/products/"], .card__title a[href*="/products/"]');
  if (!link) return null;
  const url = link.getAttribute('href');
  a = document.createElement('a');
  a.href = url;
  a.className = 'wt-button--full-width hero__button hero__button--secondary vc-notify-link';
  a.setAttribute('data-vc-notify', '');
  a.setAttribute('data-vc-qa-notify', '');
  a.dataset.handle = url.split('/products/')[1].split(/[?#]/)[0];
  a.innerHTML = '<span class="vc-notify-long">Notify me when available</span><span class="vc-notify-short">Notify me</span>';
  box.appendChild(a);
  return a;
}

function refresh(box) {
  const { variant, wanted, fallback, list } = resolve(box);
  const quick = box.parentElement.querySelector(':scope > quick-add[data-vc-qa-fallback]');
  box.hidden = fallback;
  if (quick) quick.hidden = !fallback;
  if (fallback) return null;

  const button = box.querySelector('button[name="add"]');
  const label = box.querySelector('[data-vc-qa-label]');
  const input = box.querySelector('input[name="id"]');
  const ok = Boolean(variant && variant.a);
  if (variant && input) input.value = variant.id;
  const bag = box.querySelector('[data-vc-bag]');
  if (bag && variant) {
    const ci = Number(box.dataset.vcQaColourIndex);
    bag.setAttribute('aria-label', 'Add ' + (ci >= 0 && variant.o[ci] ? variant.o[ci] + ' ' : '') + box.dataset.vcQaTitle + ' to bag');
  }
  if (button) {
    button.disabled = !ok;
    button.setAttribute('aria-disabled', String(!ok));
  }
  if (label) {
    let text = ok ? box.dataset.vcQaAdd : box.dataset.vcQaSold;
    if (ok && box.dataset.vcQaPriceVaries === 'true' && box.querySelector('.vc-qa__opt')) text += ' · ' + variant.p;
    label.textContent = text;
  }
  // vc-notify.js shows its own Notify me for a sold-out colour circle; then this box stays hidden.
  const colourNotify = box.parentElement.querySelector(':scope > [data-vc-notify-colour]:not([hidden])');
  box.hidden = Boolean(!ok && colourNotify);
  const form = box.querySelector('product-form');
  const notify = !ok && variant && !colourNotify ? notifyLink(box) : box.querySelector(':scope > [data-vc-qa-notify]');
  if (notify) {
    const show = Boolean(!ok && variant && !colourNotify);
    notify.style.display = show ? '' : 'none';
    if (show) {
      notify.dataset.variantId = variant.id;
      notify.setAttribute('aria-label', 'Notify me when available: ' + variant.o.join(' / '));
    }
    if (form) form.style.display = show ? 'none' : '';
  }

  box.querySelectorAll('.vc-qa__opt').forEach((group) => {
    const i = Number(group.dataset.vcQaIndex);
    group.querySelectorAll('.vc-qa__btn').forEach((b) => {
      const test = wanted.slice();
      test[i] = b.dataset.vcQaValue;
      const v = list.find((x) => x.o.every((val, k) => val === test[k]));
      b.classList.toggle('vc-qa__btn--sold', !(v && v.a));
    });
  });
  if (variant) markActiveCircle(box, variant);
  if (variant) showVariantPhoto(cardOf(box), variant);
  return ok ? variant : null;
}

function refreshAll(root = document) {
  root.querySelectorAll(BOX).forEach(refresh);
}

document.addEventListener(
  'click',
  (e) => {
    const pill = e.target.closest('.vc-qa__btn');
    if (pill) {
      const index = pill.closest('.vc-qa__opt').dataset.vcQaIndex;
      const value = pill.dataset.vcQaValue;
      const card = cardOf(pill.closest(BOX));
      card.querySelectorAll(`.vc-qa__opt[data-vc-qa-index="${index}"] .vc-qa__btn`).forEach((b) =>
        b.setAttribute('aria-pressed', String(b.dataset.vcQaValue === value)),
      );
      refreshAll(card);
      return;
    }
    const add = e.target.closest(BOX + ' button[name="add"]');
    if (add) {
      if (!refresh(add.closest(BOX))) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
      return;
    }
    const circle = e.target.closest('.color-swatcher--wrapper');
    if (circle) {
      const card = circle.closest('color-swatch') || circle.closest('.card-wrapper');
      setTimeout(() => card && refreshAll(card), 0);
    }
  },
  true,
);

let queued = false;
function queue() {
  if (queued) return;
  queued = true;
  requestAnimationFrame(() => {
    queued = false;
    refreshAll();
  });
}

refreshAll();
window.addEventListener('load', queue);
new MutationObserver((records) => {
  if (records.some((r) => [...r.addedNodes].some((n) => n.nodeType === 1 && (n.matches?.(BOX) || n.querySelector?.(BOX))))) queue();
}).observe(document.body, { childList: true, subtree: true });
